//@ts-ignore
import config from "config";

const calculateLinkRenewablePage = (
  period: 1 | 12,
  EmbedSubscription: string,
  Subscription: string,
  path: string
) => {
  const isYearly = period === 12;
  let subscriptionType = "";
  if (
    EmbedSubscription === "JM Embed Premium" ||
    (EmbedSubscription === "JM Embed Premium Plus" &&
      Subscription === "JM Business")
  ) {
    subscriptionType = "premium";
  } else if (Subscription === "JM Premium") {
    subscriptionType = "premium";
  } else if (Subscription === "JM Business") {
    subscriptionType = "business";
  } else if (Subscription === "JM Pro") {
    subscriptionType = "pro";
  }
  const yearlyOrMonthly = isYearly ? "yearly" : "monthly";

  if (!subscriptionType) {
    //@ts-ignore
    return `${config.baseurl}/l${path}plans`;
  }
  //@ts-ignore
  return `${config.baseurl}/l${path}purchase/${subscriptionType}/${yearlyOrMonthly}`;
};

export default calculateLinkRenewablePage;
